import { render } from "./CurriculumVitae.vue?vue&type=template&id=bb1d1b48&scoped=true"
import script from "./CurriculumVitae.vue?vue&type=script&lang=js"
export * from "./CurriculumVitae.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-bb1d1b48"

export default script